import { callApiToServer } from "../callApi";

export async function changeStatus(authtoken, categoryId, status) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      category_id: categoryId,
      is_active: status,
    });

    let endUrl = "v1/auth/admin/category/active-status-category";

    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "PUT", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
